import React, { useMemo } from 'react';

import { FiltersDatatableList } from '@europrocurement/flexy-datatable';
import { LazyBreadcrumb, ListSkeleton, SkeletonLoader } from '@europrocurement/flexy-components';

import { useDispatch, useSelector } from 'react-redux';
import {
    AchatsAppDispatch,
    AchatsStateType,
    MEDIAOBJECT_SLICE_NAME,
    MediaObjectApiObject,
    UNREGISTERED_INVOICES_DATASOURCE_NAME,
    useAchatsService,
} from '@europrocurement/l2d-domain';
import { DataSource } from '@europrocurement/l2d-redux-utils';

import UnregisteredInvoicesList from '../../../components/lists/UnregisteredInvoicesList/UnregisteredInvoicesList';

const UnregisteredInvoicesView: React.FunctionComponent = function () {
    const additionalFilters: FiltersDatatableList = useMemo(() => [], []);

    const dispatch = useDispatch<AchatsAppDispatch>();

    const dataSource = useSelector<AchatsStateType>(
        (state) => state.achats.mediaobject[UNREGISTERED_INVOICES_DATASOURCE_NAME],
    ) as DataSource<MediaObjectApiObject>;

    const { getUnregisteredMediaobject } = useAchatsService();

    React.useEffect(() => {
        // Verify that dataSource.filter only contains allowed keys

        dispatch({
            type: `${MEDIAOBJECT_SLICE_NAME}/reset${UNREGISTERED_INVOICES_DATASOURCE_NAME}Filter`,
        });
        dispatch({
            type: `${MEDIAOBJECT_SLICE_NAME}/set${UNREGISTERED_INVOICES_DATASOURCE_NAME}Filter`,
            payload: {
                key: 'forceInterne',
                value: false,
            },
        });
        dispatch({
            type: `${MEDIAOBJECT_SLICE_NAME}/set${UNREGISTERED_INVOICES_DATASOURCE_NAME}Filter`,
            payload: {
                key: 'available',
                value: true,
            },
        });
        dispatch({
            type: `${MEDIAOBJECT_SLICE_NAME}/set${UNREGISTERED_INVOICES_DATASOURCE_NAME}Filter`,
            payload: {
                key: 'processingFacture',
                value: false,
            },
        });

        dispatch(getUnregisteredMediaobject({}));
    }, [dispatch, getUnregisteredMediaobject]);

    return (
        <>
            <LazyBreadcrumb
                path={[{ path: 'Portail achats', link: '/achats/liste' }, 'Factures à traiter']}
            />
            <SkeletonLoader
                isLoading={dataSource.status === 'loading' || dataSource.status === 'idle'}
                skeleton={<ListSkeleton />}
            >
                <UnregisteredInvoicesList
                    additionalFilters={additionalFilters}
                    dataSource={dataSource}
                />
            </SkeletonLoader>
        </>
    );
};

export default UnregisteredInvoicesView;
